import { Component, OnInit, Inject, Injector } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from 'app/core/interfaces/dialog';
import { MaterialDialog } from 'app/modules/shared/components/dialog/dialog.component';
import { addressI } from 'app/core/interfaces/adress';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { MapService } from 'app/core/http/services/map.service';
import { ViaCepService } from 'app/core/http/services/viacep.service';
import { error, log } from 'console';

@Component({
  selector: 'page-search-cep',
  templateUrl: './search-cep.component.html',
  styleUrls: ['./search-cep.component.scss']
})
export class SearchCepComponent extends BaseComponent implements OnInit {

  public address: string = '';
  public result: addressI = <addressI>{};

  constructor(
    public dialogRef: MatDialogRef<MaterialDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private injector: Injector,
    private viacepService : ViaCepService
  ) { 
    super(injector);
  }

  ngOnInit(): void {
  }

  onChange() {
    this.result = this.search(this.address);
  }

  searchByRawAddress()
  {

    let [estado, cidade, logradouro] = this.address.trim().split(', ')

    this.viacepService.findRaw(estado, cidade, logradouro)
    .subscribe({
      next: (res: any) => {
      
        const address = res[0]

      
        this.result.cep = address.cep
        this.result.city = address.localidade;
        this.result.state = address?.uf;
        this.result.country = "Brasil";
        this.result.street = address?.logradouro;


        this.dialogRef.close(this.result);
      
        
      },
      error: err => {
        console.log("ERROR", err) // Posteriormente, adicionar um toastr aqui

      }
    })
      

    


  }


  search(text: string) {
    //@TODO buscar no google maps e retornar os dados
    const address: addressI = { 
      cep: '89015200',
      latitude: '-26.91639630118741', 
      longitude: '-49.05828602395934',
      street: 'R. Itajaí...',
      district: 'Vorstadt',
      city: 'Blumenau',
      state: 'SC',
      country: 'Brasil'
     };
    return address;
  }




  send() {
    this.dialogRef.close(this.result);
  }

}
